/* Aseli category navigation (collection pages).
   1) Facet switching: row 1 segments toggle the row 2 chip panels
      (all panels are server-rendered; JS only toggles visibility).
   2) "Alle Kategorien" bottom sheet: open/close (chip, backdrop, X, ESC),
      drag/swipe-down to dismiss (grab zone), accordion groups,
      live search across all category links, body scroll lock while open. */
(function () {
  'use strict';

  if (window.aseliCategoryNavInit) return;
  window.aseliCategoryNavInit = true;

  var nav = document.querySelector('[data-aseli-catnav]');
  if (!nav) return;

  /* ------------------------------ Facet switching ------------------------------ */

  var tabs = nav.querySelectorAll('[data-facet-tab]');
  var panels = nav.querySelectorAll('[data-facet-panel-wrapper]');

  function activateFacet(key) {
    Array.prototype.forEach.call(tabs, function (tab) {
      var isActive = tab.getAttribute('data-facet-tab') === key;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    Array.prototype.forEach.call(panels, function (panel) {
      panel.classList.toggle('is-hidden', panel.getAttribute('data-facet-panel-wrapper') !== key);
    });
    var scroller = nav.querySelector('[data-catnav-scroller]');
    if (scroller) scroller.scrollLeft = 0;
  }

  Array.prototype.forEach.call(tabs, function (tab) {
    tab.addEventListener('click', function () {
      activateFacet(tab.getAttribute('data-facet-tab'));
    });
  });

  /* ------------------------------ Category sheet ------------------------------ */

  var sheet = document.querySelector('[data-aseli-catsheet]');
  if (!sheet) return;

  var panel = sheet.querySelector('[data-catsheet-panel]');
  var grab = sheet.querySelector('[data-catsheet-grab]');
  var searchInput = sheet.querySelector('[data-catsheet-search]');
  var emptyNote = sheet.querySelector('[data-catsheet-empty]');
  var groups = sheet.querySelectorAll('[data-catsheet-group]');
  var openers = document.querySelectorAll('[data-catsheet-open]');
  var lastFocused = null;
  var dragStartY = null;
  var dragY = 0;

  function lockScroll() {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function openSheet() {
    if (sheet.getAttribute('data-open') === 'true') return;
    lastFocused = document.activeElement;
    sheet.removeAttribute('hidden');
    // next frame so the entrance transition picks up from translateY(100%)
    window.requestAnimationFrame(function () {
      sheet.setAttribute('data-open', 'true');
    });
    lockScroll();
    // Focus the close button (NOT the search input — mobile keyboards popping
    // up unasked confuse the 40+ target group; keyboard users still land on
    // a sensible first stop).
    var closeBtn = sheet.querySelector('.aseli-catsheet__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeSheet() {
    if (sheet.getAttribute('data-open') !== 'true') return;
    sheet.setAttribute('data-open', 'false');
    resetDrag();
    unlockScroll();
    window.setTimeout(function () {
      sheet.setAttribute('hidden', 'hidden');
    }, 280); // matches the panel transition
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  Array.prototype.forEach.call(openers, function (btn) {
    btn.addEventListener('click', openSheet);
  });

  Array.prototype.forEach.call(sheet.querySelectorAll('[data-catsheet-close]'), function (el) {
    el.addEventListener('click', closeSheet);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet.getAttribute('data-open') === 'true') closeSheet();
  });

  /* Drag / swipe down to dismiss (grab zone only) */
  function resetDrag() {
    dragStartY = null;
    dragY = 0;
    panel.style.transform = '';
    panel.style.transition = '';
  }

  if (grab && panel) {
    grab.addEventListener('pointerdown', function (e) {
      dragStartY = e.clientY;
      panel.style.transition = 'none';
      if (grab.setPointerCapture) grab.setPointerCapture(e.pointerId);
    });

    grab.addEventListener('pointermove', function (e) {
      if (dragStartY === null) return;
      dragY = Math.max(0, e.clientY - dragStartY);
      panel.style.transform = 'translateY(' + dragY + 'px)';
    });

    var endDrag = function () {
      if (dragStartY === null) return;
      var shouldClose = dragY > 90;
      dragStartY = null;
      panel.style.transition = '';
      if (shouldClose) {
        closeSheet();
      } else {
        dragY = 0;
        panel.style.transform = '';
      }
    };

    grab.addEventListener('pointerup', endDrag);
    grab.addEventListener('pointercancel', endDrag);
  }

  /* Accordion groups */
  Array.prototype.forEach.call(groups, function (group) {
    var toggle = group.querySelector('[data-catsheet-accordion]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var isOpen = group.getAttribute('data-open') === 'true';
      group.setAttribute('data-open', isOpen ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  /* Live search across all category links */
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim().toLowerCase();
      var anyVisible = false;

      Array.prototype.forEach.call(groups, function (group) {
        var items = group.querySelectorAll('[data-catsheet-item]');
        var visibleInGroup = 0;

        Array.prototype.forEach.call(items, function (item) {
          var matches = !q || (item.getAttribute('data-search-text') || item.textContent).indexOf(q) !== -1;
          item.style.display = matches ? '' : 'none';
          if (matches) visibleInGroup++;
        });

        var groupVisible = visibleInGroup > 0;
        group.style.display = groupVisible ? '' : 'none';
        if (groupVisible) anyVisible = true;
        // while searching, keep every non-empty group expanded
        if (q) group.setAttribute('data-open', 'true');
      });

      if (emptyNote) emptyNote.hidden = anyVisible;
      sheet.setAttribute('data-searching', q ? 'true' : 'false');
    });
  }
})();
